import { getVariantPageUrl, isBasicPlanOffer, isApiDietTargetSystem, getPaymentQueryString } from "./helpers"

import { getOfferPriceId } from "./pricing"

const getGA4SessionId = () => {
  try {
    const cookies = document.cookie
      .split("; ")
      .find((item) => item.includes("_ga_"))
      .split("=")[1]
    return cookies.split(".")[2]
  } catch (e) {
    console.error(`GA4 session ID not found`)
  }
  return undefined
}

const getFbAdsId = (store) => store.values.fb_ad_id || store.values.fb_ads_id || undefined

const callPaymentsApi = async ({ paymode, offer, restrictSaveCard }) => {
  const store = Alpine.store("data")

  const activeOffer = offer || store.values.activeOffer

  const isBasicPlan = isBasicPlanOffer(activeOffer)
  const isChance = isBasicPlan && store.values.exitIntent

  const url = new URL(pipelineConfig.paymentsApiUrl)
  url.pathname = "/api/v1/payments"

  const originUrl = new URL(window.location.origin.replace("localhost:8080", "lvh.me"))
  originUrl.pathname = pipelineConfig.pathPrefix

  const res = await fetch(url.toString(), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      brandCode: pipelineConfig.brandCode,
      provider: paymode || "primer",
      source: "cppv3",
      customerId: store.values.customerId,
      orderId: store.values.id?.toString(),
      orderToken: store.values.token,
      originUrl: originUrl?.toString(),
      fbp: store.values._fbp,
      fbc: store.values._fbc,
      gaCid: store.values._ga?.match(/[^\.]+\.[^\.]+$/)?.[0],
      gaSessionId: getGA4SessionId(),
      utmCampaign: store.values.utm_campaign,
      utmSource: store.values.utm_source,
      utmMedium: store.values.utm_medium,
      utmTerm: store.values.utm_term,
      utmContent: store.values.utm_content,
      fraudNetSessionId: store.values.fraud_net_session_id,
      // For the basic offer and upsells payments views - we restrict buy from saved card.
      // For the upsells offer-views with 1 click purchase - we use the saved card.
      restrictSaveCard,
      trackingProperties: {
        fb_ads_id: getFbAdsId(store),
        fb_adset_id: store.values.fb_adset_id || undefined,
        cookies: store.values.cookies || undefined,
        ...getPaymentQueryString(store),
      },
      ...(isApiDietTargetSystem(activeOffer)
        ? {
            // API DIET
            offerId: activeOffer.brandOfferId,
            offerPriceId: getOfferPriceId({ offer: activeOffer, isChance }),
          }
        : {
            // NPS
            priceProductObjectId: isChance
              ? activeOffer.exitIntentPriceProductObjectId
              : activeOffer.priceProductObjectId,
            pipelineOfferType: activeOffer.type,
          }),
    }),
  })

  if (!res.ok) {
    throw new Error(`HTTP error occurred: ${res.status}`)
  }

  return res.json()
}

const getPaymentSuccessUrl = ({ checkoutSession, pagePath }) => {
  const store = Alpine.store("data")

  const successUrl = getVariantPageUrl({ pagePath, pipelineConfig })

  const { trackingEvent } = checkoutSession
  const params = new URLSearchParams({
    invoice_id: trackingEvent?.messageId,
    invoice_amount: trackingEvent?.amountInEuro,
    ga_transaction_id: trackingEvent?.messageId,
    order_id: trackingEvent ? store.values.id : undefined,
    ga_currency: trackingEvent?.currency,
    ga_value: trackingEvent?.amount,
  })

  if (!isApiDietTargetSystem(store.values.activeOffer) && trackingEvent?.pipelineOfferType) {
    params.set("pipeline_offer_type", trackingEvent.pipelineOfferType)
  } else if (trackingEvent?.offerType) {
    params.set("offer_type", trackingEvent.offerType)
  }

  return `${successUrl}?${params.toString()}`
}

const getPaymentFailUrl = ({ paymode = "primer", pagePath }) => {
  const url = getVariantPageUrl({ pagePath, pipelineConfig })
  return `${url}?error=${paymode}`
}

// Paypal, etc
const createRedirectCheckout = async (paymode) => {
  const store = Alpine.store("data")

  try {
    const checkout = await callPaymentsApi({
      paymode,
    })

    store.values.checkout = checkout
    store.values.initiateCheckoutAt = new Date().toISOString()

    window.location = checkout.url
  } catch (e) {
    throw e
  }
}

// Primer
const createPrimerCheckoutSession = async ({ restrictSaveCard } = {}) => {
  const paymode = "primer"

  try {
    const checkoutSession = await callPaymentsApi({
      paymode,
      restrictSaveCard,
    })

    return checkoutSession
  } catch (e) {
    throw e
  }
}

export {
  createRedirectCheckout,
  createPrimerCheckoutSession,
  getPaymentSuccessUrl,
  getPaymentFailUrl,
}
